import React from "react";

const CustomerHeroSection = ({ customer, customer_key_points = [] }) => {
  const title = customer?.data?.title?.text;
  const imageUrl = customer?.data?.image?.url;
  const subImageUrl = customer?.data?.sub_image?.url;
  const stats = customer_key_points.flatMap((slice) => slice.items || []);
  const visibleStats = stats.slice(0, 3);

  return (
    <div className="relative w-full min-h-[calc(100vh-107px)] overflow-hidden">
      {imageUrl && (
        <img
          src={imageUrl}
          loading="eager"
          alt={title || "customer hero"}
          className="absolute inset-0 w-full h-full object-cover z-0"
        />
      )}
      <div className="absolute inset-0 bg-black/40 z-10" />

      <div className="relative z-10 flex min-h-[calc(100vh-147px)] flex-col justify-end sm:gap-10 gap-6 h-full pb-10 pt-[144px]  max-w-7xl px-5 sm:px-6 xl:px-16 mx-auto">
        {subImageUrl && (
          <img
            src={subImageUrl}
            loading="eager"
            alt="sub hero"
            className="z-10 w-44"
          />
        )}

        <h1 className="text-white text-3.25xl max-w-full sm:text-[44px] lg:text-4.5xl leading-10 sm:leading-11 md:leading-12 font-semibold md:tracking-tightest_4 font-manrope drop-shadow-lg ">
          {title}
        </h1>
        {visibleStats.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-6 justify-between">
            {visibleStats.map((point, idx) => (
              <div
                key={idx}
                className={`flex flex-col w-full ${
                  idx < visibleStats.length - 1
                    ? "sm:border-r border-b sm:border-b-0 border-gray-300"
                    : ""
                }`}
              >
                <span className="text-white text-2.25xl lg:text-3.25xl font-semibold leading-tight">
                  {point.card_title?.text}
                </span>
                {point.card_description?.text && (
                  <span className="text-gray-200 text-base lg:text-xl mt-1 pb-2 sm:pb-0">
                    {point.card_description?.text}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomerHeroSection;
